import React from 'react';

import './panel.css';

function Panel(props) {
    const { 
        email, 
        onUserInput, 
        copyLinks, 
        emailLinks
    } = props;

    return (
        <div className='_panel'>
            <form className='form' onSubmit={emailLinks}>
                <button 
                    className='button'
                    type='button'
                    onClick={copyLinks}
                >
                    <i className='icon fas fa-copy'></i>
                    &nbsp; Copy Links
                </button>
                <input 
                    className='input' 
                    type='email'
                    name='email'
                    value={email}
                    placeholder='Enter email'
                    onChange={onUserInput}
                />
                <button 
                    className='button'
                    type='submit'
                >
                    <i className='icon fas fa-envelope'></i>
                    &nbsp; Email Links
                </button>
            </form>
        </div>
    );
}

export default Panel;